var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33366 2V2.33333C5.33366 2.88562 5.78137 3.33333 6.33366 3.33333H9.66699C10.2193 3.33333 10.667 2.88562 10.667 2.33333V2H12.0003C12.7367 2 13.3337 2.59695 13.3337 3.33333V14C13.3337 14.7364 12.7367 15.3333 12.0003 15.3333H4.00033C3.26395 15.3333 2.66699 14.7364 2.66699 14V3.33333C2.66699 2.59695 3.26395 2 4.00033 2H5.33366Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 1.33329C7.33333 0.965103 7.63181 0.666626 8 0.666626C8.36819 0.666626 8.66667 0.965103 8.66667 1.33329H9.66667C9.85076 1.33329 10 1.48253 10 1.66663V2.33329C10 2.51739 9.85076 2.66663 9.66667 2.66663H6.33333C6.14924 2.66663 6 2.51739 6 2.33329V1.66663C6 1.48253 6.14924 1.33329 6.33333 1.33329H7.33333Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.667 6H7.33366C6.96547 6 6.66699 6.29848 6.66699 6.66667C6.66699 7.03486 6.96547 7.33333 7.33366 7.33333H10.667C11.0352 7.33333 11.3337 7.03486 11.3337 6.66667C11.3337 6.29848 11.0352 6 10.667 6Z",
    fill: "#0078D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.00033 6.66667C6.00033 6.29848 5.70185 6 5.33366 6C4.96547 6 4.66699 6.29848 4.66699 6.66667C4.66699 7.03486 4.96547 7.33333 5.33366 7.33333C5.70185 7.33333 6.00033 7.03486 6.00033 6.66667Z",
    fill: "#0078D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.00033 9.33329C6.00033 8.9651 5.70185 8.66663 5.33366 8.66663C4.96547 8.66663 4.66699 8.9651 4.66699 9.33329C4.66699 9.70148 4.96547 9.99996 5.33366 9.99996C5.70185 9.99996 6.00033 9.70148 6.00033 9.33329Z",
    fill: "#0078D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.667 8.66663H7.33366C6.96547 8.66663 6.66699 8.9651 6.66699 9.33329C6.66699 9.70148 6.96547 9.99996 7.33366 9.99996H10.667C11.0352 9.99996 11.3337 9.70148 11.3337 9.33329C11.3337 8.9651 11.0352 8.66663 10.667 8.66663Z",
    fill: "#0078D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.00033 12C6.00033 11.6319 5.70185 11.3334 5.33366 11.3334C4.96547 11.3334 4.66699 11.6319 4.66699 12C4.66699 12.3682 4.96547 12.6667 5.33366 12.6667C5.70185 12.6667 6.00033 12.3682 6.00033 12Z",
    fill: "#0078D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.667 11.3334H7.33366C6.96547 11.3334 6.66699 11.6319 6.66699 12C6.66699 12.3682 6.96547 12.6667 7.33366 12.6667H10.667C11.0352 12.6667 11.3337 12.3682 11.3337 12C11.3337 11.6319 11.0352 11.3334 10.667 11.3334Z",
    fill: "#0078D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramActive);
export default __webpack_public_path__ + "static/media/program_active.3cd89b20.svg";
export { ForwardRef as ReactComponent };